import fraggin from "$javascript/fraggin.js"

const header = document.querySelector("body > header")
if (!header.hasAttribute("logged-in")) {
  fraggin("/account/profile?skipperks=1").then(frag => {
    const query = 'ul[slot="nav"] > li:nth-child(1)'
    header.querySelector(query).replaceChildren(...frag.querySelector(query).children)
  })
}
